import { connect } from 'react-redux';
import * as Store from '@apply/store';
import DataGrid, { Column, Paging, Pager, ColumnFixing } from 'devextreme-react/data-grid';
import { ExperienceProjectTypeOptions } from '@apply/constants';
import { Tooltip } from '@material-ui/core';

const ExperienceUnableToVerifyGrid = ({ unverifiableExperiences }) => {
    const allowedPageSizes = [15, 25, 50];
    const defaultPageSize = allowedPageSizes[0];

    const styles = {
        unverifiableExperienceContainer: {
            width: '100%' as const,
        },
        verticalPadding: {
            paddingTop: 50,
            paddingBottom: 50,
        },
    };

    const onProjectTypeCellRender = (e) => {
        const option = ExperienceProjectTypeOptions.find((a) => a.id === e.value);
        return <span>{option?.name ?? 'Unknown'}</span>;
    };

    const formatAddress = (e) => {
        if (e.data.street2) {
            return `${e.data.street1} ${e.data.street2}, ${e.data.city}, ${e.data.state} ${e.data.zipCode}`;
        } else {
            return `${e.data.street1}, ${e.data.city}, ${e.data.state} ${e.data.zipCode}`;
        }
    };

    const onAddressCellRender = (e) => {
        if (!e.data) {
            return null;
        }
        if (e.data.street2) {
            return (
                <Tooltip title={formatAddress(e)}>
                    <span>{formatAddress(e)}</span>
                </Tooltip>
            );
        } else {
            return (
                <Tooltip title={formatAddress(e)}>
                    <span>{formatAddress(e)}</span>
                </Tooltip>
            );
        }
    };

    return (
        <>
            <div style={{ paddingTop: '20px' }}>
                <h4>Unable to Verify or Other Issue</h4>
                {unverifiableExperiences?.length > 0 && (
                    <div
                        className='columns small-12 large-12'
                        style={styles.unverifiableExperienceContainer}
                    >
                        <DataGrid
                            keyExpr='id'
                            id='experienceTable'
                            dataSource={unverifiableExperiences}
                            showBorders={true}
                            showRowLines={true}
                            remoteOperations={false}
                            allowColumnResizing={true}
                            allowColumnReordering={false}
                            columnResizingMode={'nextColumn'}
                            columnMinWidth={20}
                            cellHintEnabled={true}
                            width={'auto'}
                        >
                            <ColumnFixing enabled={true} />
                            <Column
                                caption='Project Type'
                                dataField='projectTypeId'
                                alignment={'left'}
                                minWidth={130}
                                allowSorting={false}
                                cellRender={onProjectTypeCellRender}
                            />
                            <Column
                                caption='Address'
                                alignment='left'
                                minWidth={120}
                                allowSorting={false}
                                cellRender={onAddressCellRender}
                            />
                            <Paging defaultPageSize={defaultPageSize} />
                            <Pager
                                showPageSizeSelector={allowedPageSizes.length > 1}
                                allowedPageSizes={allowedPageSizes}
                                showNavigationButtons={true}
                                showInfo={true}
                                visible={true}
                            />
                        </DataGrid>
                    </div>
                )}
                {!unverifiableExperiences?.length && (
                    <ul>
                        <li>
                            <em>None</em>
                        </li>
                    </ul>
                )}
            </div>
        </>
    );
};

export const mapStateToProps = (state: Store.ApplyRootStateType) => ({
    unverifiableExperiences: state.user?.unverifiableExperiences ?? [],
});

export default connect(mapStateToProps)(ExperienceUnableToVerifyGrid);
